@if (visible()) {
  <div #banner class="cookie-banner" role="dialog" aria-modal="true" aria-label="Cookie consent">
    <div class="cookie-banner__bar">
      <div class="cookie-banner__inner">
        <div class="cookie-banner__text">
          <h2 class="cookie-banner__title type-title-h8">Cookies</h2>
          @if (decision()?.analytics) {
            <p class="cookie-banner__description type-body-b3">
              Analytics cookies are on. Rejecting turns them off immediately and clears what has
              already been set.
              <br />
              Accepted {{ decision()?.consentedAt | date: 'd MMMM y' }} ·
              <a class="cookie-banner__link link__accent" routerLink="/cookie-policy"
                >Cookie policy</a
              >
            </p>
          } @else {
            <p class="cookie-banner__description type-body-b3">
              Essential cookies keep evrn.world working. Analytics cookies show us which pages
              people visit and where they leave — never tied back to you, never advertising. They
              only run if you accept.
              <a class="cookie-banner__link link__accent" routerLink="/cookie-policy"
                >Cookie policy</a
              >
            </p>
          }
        </div>

        <div class="cookie-banner__actions">
          <app-button variant="secondary" [fullWidth]="isMobile()" (click)="rejectAll()"
            >Reject all
          </app-button>
          <app-button variant="secondary" [fullWidth]="isMobile()" (click)="acceptAll()"
            >Accept all
          </app-button>
        </div>
      </div>
    </div>
  </div>
}
